<!-- <div class="row">
  <div class="col">
    <h1>{{ info.title }}</h1>
  </div>
</div> -->
<div class="row" *ngIf="language === 'ES'">
  <div class="col">
    <p>Por que queremos celebrar todos en familia este año que acaba de pasar, no tendremos servicio el dia de hoy.</p>
    <br>
    <p>El lunes 2 de enero estaremos listos y recargados para servirles.</p>
    <br>
    <strong>Café General</strong>
    <br>
    <strong>Grupo Sinmente</strong>
  </div>
</div>
<div class="row" *ngIf="language === 'EN'">
  <div class="col">
    <p>Because we all want to celebrate as a family this year that has just passed, we will not have service today.</p>
    <br>
    <p>On monday, January 2, we will be ready and recharged to serve you.</p>
    <br>
    <strong>Café General</strong>
    <br>
    <strong>Grupo Sinmente</strong>
  </div>
</div>